<template>
  <div class="container patients">
    <div class="row">
      <div class="col-12 col-md-9">
        <h1 class="mb-45">
          Clients
        </h1>
      </div>
      <div v-if="!schedulingActive" class="col-12 col-md-3 text-right">
        <form-component>
          <div class="form-row">
            <div class="col-12">
              <input-text
                id="searchCriteria"
                v-model="searchCriteria"
                name="searchCriteria"
                label="Search"
              />
            </div>
          </div>
        </form-component>
      </div>
    </div>

    <div v-if="firstLoading" class="row">
      <Loader style="width: 100%;" />
    </div>
    <div v-else-if="!clients.length && !loading" class="row">
      You do not have any clients.
    </div>
    <div v-else class="row">
      <div class="col-12">
        <div v-if="!schedulingActive" class="dashboard-card d-none d-md-block">
          <clients-table :clients="clients" :schedule-for-client="scheduleForClient" />
          <div class="text-center mt-2">
            <Loader v-if="loading" style="width: 100%" />
            <button v-else-if="nextPageToken" class="btn btn-primary" @click="loadClients">
              Load More Clients
            </button>
          </div>
        </div>
        <div v-if="!schedulingActive" class="d-md-none">
          <clients-table :clients="clients" :schedule-for-client="scheduleForClient" />
          <Loader v-if="loading" style="width: 100%" />
          <button v-else-if="nextPageToken" class="btn" @click="loadClients">
            Load More Clients
          </button>
        </div>
        <div v-if="schedulingActive" class="dashboard-card d-md-block">
          <div class="row">
            <div class="col-12 col-md-6">
              <button class="btn btn-ghost" @click="clearScheduling">Back</button>
            </div>
            <div class="col-12 col-md-6 pr-0 pr-md-5 pt-4 pt-md-0 text-md-right text-center">
              <h3>{{ selectedClient.name }}</h3>
            </div>
          </div>
          <hr />
          <client-scheduler
            :client="selectedClient"
            :counselor-id="counselorId"
            @clear-scheduling="clearScheduling"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ClientsTable from './components/ClientsTable.vue';
import CounselorClient from '@/api/CounselorClient';
import Loader from '@/components/Loader.vue';
import InputText from '@/components/inputs/InputText.vue';
import FormComponent from '@/components/FormComponent.vue';
import ClientScheduler from './components/ClientScheduler.vue';

export default {
    name: 'Payments',
    components: {
        ClientsTable,
        Loader,
        InputText,
        FormComponent,
        ClientScheduler
    },
    data() {
        return {
            counselorClient: new CounselorClient(this.$http),
            clients: [],
            nextPageToken: null,
            loading: false,
            firstLoading: true,
            searchCriteria: '',
            schedulingActive: false,
            selectedClient: '',
            counselorId: this.$store.getters.currentUser.counselor_profile.id
        };
    },
    watch: {
        searchCriteria() {
            if (this.searchTimeout) clearTimeout(this.searchTimeout);

            this.searchTimeout = setTimeout(
                () => {
                    this.nextPageToken = null;
                    this.clients.length = 0;
                    this.loading = true;
                    this.loadClients()
                },
                333);
        },
    },
    async mounted() {
        this.loadClients();
      },

    methods: {
        async loadClients() {
            try {
                this.loading = true;
                const searchCriteria = this.searchCriteria.split(/\s/).filter(Boolean);

                const response = await this.counselorClient.getCounselorClients(
                    this.counselorId,
                    searchCriteria.length ? searchCriteria : undefined,
                    this.nextPageToken);

                this.nextPageToken = response.nextPageToken;
                for (const result of response.counselorClients) {
                  this.clients.push({
                    ...result,
                    client: {
                      ...result.client,
                      // Legacy Fields needed for Book Appointment
                      id: result.client.clientId,
                      name: `${result.client.firstName} ${result.client.lastName}`,
                      first_name: result.client.firstName,
                      last_name: result.client.lastName,
                    }
                  });
                }
            } catch (ex) {
                console.error(ex);
            } finally {
                this.loading = false;
                this.firstLoading = false;
            }
        },
        clearScheduling() {
          this.schedulingActive = false;
          this.selectedClient = '';
        },
        async scheduleForClient(row) {
          this.selectedClient = row.client;
          this.schedulingActive = true;
        },
    }
};
</script>
